import ApiMServer from "services/ApiMServer";

export const getUnits = async () => {
  try {
    const { data } = await ApiMServer.get("/company/v1/getunits");
    return data;
  } catch (error) {
    console.error("Erro ao buscar unidades:", error.message);
    return [];
  }
};

export default {
  getUnits,
};
